import PropTypes from "prop-types";

export default function ParameterCard({ parameter, onOpen, onCopy }) {
    const initial = (parameter.name || parameter.systemName || "?")
        .toString()
        .trim()
        .charAt(0)
        .toUpperCase();

    return (
        <article className="card item-card">
            <div className="card-body">
                {/* Header */}
                <header className="item-card__header">
                    <div className="item-card__title-block">
                        <div className="item-card__avatar">
                            <span>{initial}</span>
                        </div>
                        <div>
                            <h2 className="card-title item-card__title">
                                {parameter.name || parameter.systemName}
                            </h2>
                            <p className="card-subtle">
                                {parameter.systemName}
                            </p>
                        </div>
                    </div>

                    <span className="chip">
                        {parameter.valueTypeCode || parameter.valueType}
                    </span>
                </header>

                {/* Description */}
                {parameter.description && (
                    <p className="card-section muted item-card__description">
                        {parameter.description}
                    </p>
                )}

                {/* Parameter Details */}
                <dl className="item-card__params">
                    <div className="item-card__param-row">
                        <dt className="eyebrow">
                            Default Value
                        </dt>
                        <dd className="chip-value font-mono">
                            {parameter.defaultValue == null ? "—" : JSON.stringify(parameter.defaultValue)}
                        </dd>
                    </div>
                    {parameter.options && (
                        <div className="item-card__param-row">
                            <dt className="eyebrow">
                                Options
                            </dt>
                            <dd className="chip-value font-mono text-xs break-all">
                                {typeof parameter.options === "string" ? parameter.options : JSON.stringify(parameter.options)}
                            </dd>
                        </div>
                    )}
                </dl>

                {/* Footer */}
                <footer className="item-card__footer">
                    <button
                        className="btn btn-outline"
                        onClick={() => onOpen?.(parameter)}
                    >
                        Открыть
                    </button>
                    <button
                        className="btn btn-soft-accent"
                        onClick={() => onCopy?.(parameter)}
                    >
                        Копировать
                    </button>
                </footer>
            </div>
        </article>
    );
}

ParameterCard.propTypes = {
    parameter: PropTypes.shape({
        id: PropTypes.string,
        parameterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        systemName: PropTypes.string.isRequired,
        name: PropTypes.string,
        description: PropTypes.string,
        valueType: PropTypes.string,
        valueTypeCode: PropTypes.string,
        defaultValue: PropTypes.any,
        options: PropTypes.any,
    }).isRequired,
    onOpen: PropTypes.func,
    onCopy: PropTypes.func,
};
